
import store from '../../store';
import Vue from 'vue';

const success = (data, resolve) => {
  const soldProductsWidgetsData = data;
  store.dispatch('fetchSoldProductsDataWidgets', soldProductsWidgetsData);
  resolve();
};

const failed = (error, reject) => reject(error);

export default (filter = 'last_3_months') => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`user-widgets/sold-products/${filter}`)
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/widgets/fetchSoldProductsWidgets.js